import { escapeHtml as l } from "../../../../utils/common/index.js";
const h = (r) => m(r).startsWith("bn-"), m = (r) => {
  const n = r.className;
  return typeof n != "string" ? "" : n;
}, i = (r) => r ? r === "right" ? "end" : r : "start";
async function f(r, n = !1) {
  var o;
  try {
    const e = (r == null ? void 0 : r.document) || [];
    if (!e) return "";
    if ((e == null ? void 0 : e.length) === 1) {
      const t = e[0];
      if ((t == null ? void 0 : t.type) === "paragraph" && !((o = t == null ? void 0 : t.content) != null && o.length))
        return console.error("⭐ 沒有內容"), "";
    }
    const c = await (r == null ? void 0 : r.blocksToHTMLLossy(e || [])), s = new DOMParser().parseFromString(c, "text/html");
    s.body.querySelectorAll("[data-html]").forEach((t) => {
      t.removeAttribute("data-html");
    }), s.body.querySelectorAll("p").forEach((t) => {
      t.innerHTML.trim() === "" && (t.innerHTML = "&nbsp;");
    });
    const a = s.body.innerHTML;
    return n ? l(a) : `<div class="power-editor">${a}</div>`;
  } catch (e) {
    return console.error("BlockNote getHtml error:", e), "";
  }
}
export {
  f as getEditorHtml,
  m as getEleClassName,
  h as isLegacy,
  i as toFlexAlign
};
